import { HttpErrorResponse } from '@angular/common/http';
import { ModelAttributes } from '@app/core/interface/common';
import {
  INotarizationInfo,
  IProxy,
  IConsultPerson,
  IWitness
} from '@app/modules/living-will/interface/living-will';
import { IGeneralInfo } from '@app/modules/living-will/interface/general-info';

export namespace LivingWillActions {
  /**
   * @action GetGeneralInfo
   */
  export class GetGeneralInfo {
    static type = '[LivingWill] GetGeneralInfo';
  }
  export class GetGeneralInfoSuccess {
    static type = '[LivingWill] GetGeneralInfoSuccess';
  }
  export class GetGeneralInfoFailed {
    static type = '[LivingWill] GetGeneralInfoFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateGeneralInfo
   */
  export class UpdateGeneralInfo {
    static type = '[LivingWill] UpdateGeneralInfo';
    constructor(public model: IGeneralInfo, public key: string) {}
  }
  export class UpdateGeneralInfoSuccess {
    static type = '[LivingWill] UpdateGeneralInfoSuccess';
    constructor(public key: string) {}
  }
  export class UpdateGeneralInfoFailed {
    static type = '[LivingWill] UpdateGeneralInfoFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action GetLivingWill
   */
  export class GetLivingWill {
    static type = '[LivingWill] GetLivingWill';
  }
  export class GetLivingWillSuccess {
    static type = '[LivingWill] GetLivingWillSuccess';
  }
  export class GetLivingWillFailed {
    static type = '[LivingWill] GetLivingWillFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateLiving
   */
  export class UpdateLivingWillSuccess {
    static type = '[LivingWill] UpdateLivingWillSuccess';
    constructor(public key: string) {}
  }

  export class UpdateLivingWillFailed {
    static type = '[LivingWill] UpdateLivingWillFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateLWPersonalInfo
   */
  export class UpdateLWPersonalInfo {
    static type = '[LivingWill] UpdateLWPersonalInfo';
    constructor(public model: ModelAttributes,  public key: string) {}
  }

  /**
   * @action UpdateLWANotarization
   */
  export class UpdateLWANotarization {
    static type = '[LivingWill] UpdateLWANotarization';
    constructor(public notarizationInfo: INotarizationInfo, public key: string) {}
  }

  /**
   * @action AddNextOfKin
   */
  export class AddNextOfKin {
    static type = '[LivingWill] AddNextOfKin';
    constructor(public model: ModelAttributes) {}
  }
  export class AddNextOfKinSuccess {
    static type = '[LivingWill] AddNextOfKinSuccess';
  }
  export class AddNextOfKinFailed {
    static type = '[LivingWill] AddNextOfKinFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateNextOfKin
   */
  export class UpdateNextOfKin {
    static type = '[LivingWill] UpdateNextOfKin';
    constructor(public model: ModelAttributes) {}
  }
  export class UpdateNextOfKinSuccess {
    static type = '[LivingWill] UpdateNextOfKinSuccess';
  }
  export class UpdateNextOfKinFailed {
    static type = '[LivingWill] UpdateNextOfKinFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action DeleteNextOfKin
   */
  export class DeleteNextOfKin {
    static type = '[LivingWill] DeleteNextOfKin';
  }
  export class DeleteNextOfKinSuccess {
    static type = '[LivingWill] DeleteNextOfKinSuccess';
  }
  export class DeleteNextOfKinFailed {
    static type = '[LivingWill] DeleteNextOfKinFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateProxy
   */
  export class UpdateProxy {
    static type = '[LivingWill] UpdateProxy';
    constructor(public model: IProxy, public key?: string) {}
  }
  export class UpdateProxySuccess {
    static type = '[LivingWill] UpdateProxySuccess';
    constructor(public key?: string) {}
  }
  export class UpdateProxyFailed {
    static type = '[LivingWill] UpdateProxyFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateAgentAuthority — Part I E (people to consult), G (health
   * information access) and H (when the agent's power begins). Partial by
   * design: sending one answer must not clear the others.
   */
  export class UpdateAgentAuthority {
    static type = '[LivingWill] UpdateAgentAuthority';
    constructor(
      public model: {
        agentConsultPeople?: IConsultPerson[];
        agentAuthorityEffective?: string;
        agentHealthInfoOptOut?: boolean;
      },
      public key?: string,
    ) {}
  }
  export class UpdateAgentAuthoritySuccess {
    static type = '[LivingWill] UpdateAgentAuthoritySuccess';
    constructor(public key?: string) {}
  }
  export class UpdateAgentAuthorityFailed {
    static type = '[LivingWill] UpdateAgentAuthorityFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateWitness
   */
  export class UpdateWitness {
    static type = '[LivingWill] UpdateWitness';
    constructor(public model: IWitness, public key: string) {}
  }
  export class UpdateWitnessSuccess {
    static type = '[LivingWill] UpdateWitnessSuccess';
    constructor(public key: string) {}
  }
  export class UpdateWitnessFailed {
    static type = '[LivingWill] UpdateWitnessFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action DeleteProxy
   */
  export class DeleteProxy {
    static type = '[LivingWill] DeleteProxy';
    constructor(public id: number) {}
  }
  export class DeleteProxySuccess {
    static type = '[LivingWill] DeleteProxySuccess';
  }
  export class DeleteProxyFailed {
    static type = '[LivingWill] DeleteProxyFailed';
    constructor(public error?: HttpErrorResponse) {}
  }
}
